<template>
  <section class="section">
    <b-row>
      <b-col align="right" justify="center">
       <span style="font-size:24px;">不要データ削除</span>
      </b-col>
      <b-col>
         <b-form-select v-model="myServiceSelected" :options="myService" class="mb-3" />
      </b-col>
      <b-col align="right">
        <b-button variant="outline-primary" @click="onClick()">実行</b-button>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row>
      <b-col align="right" justify="center">
       <span style="font-size:24px;">Make Chat Statics</span>
      </b-col>
      <b-col></b-col>
      <b-col align="right">
        <b-button variant="outline-primary" @click="onMakeChatStatics()">実行</b-button>
      </b-col>
      <b-col></b-col>
    </b-row>
  </section>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      myService: [],
      myServiceSelected: null
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      chatStatics: 'chatStatics/chats'
    })
  },
  created () {
    this.createServiceSelector()
  },
  methods: {
    userClean (user) {
      return new Promise((resolve) => {
        var before = JSON.parse(JSON.stringify(user))
        var payload = JSON.parse(JSON.stringify(user))
        var tempG = {}
        var tempS = {}
        var keys = Object.keys(payload.groups)
        for (var x in keys) {
          if (payload.groups[keys[x]]) {
            tempG[keys[x]] = true
          }
        }
        keys = Object.keys(payload.services)
        for (x in keys) {
          if (payload.services[keys[x]]) {
            tempS[keys[x]] = true
          }
        }
        payload.services = tempS
        payload.groups = tempG
        payload.updatedAt = parseInt(new Date().getTime() / 1000)

        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        const batch = db.batch()
        var refuser = db.collection('users').doc(user.key)
        batch.set(refuser, payload)

        for (var key in before.services) {
          var index = this.services.findIndex(service => service.key === key)
          if (index === -1) {
            continue
          }
          if (!payload.services[key] && before.services[key]) {
            var refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            var refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.delete(refChatsRefTo)
          }
        }

        for (key in before.groups) {
          index = this.groups.findIndex(group => group.key === key)
          if (index === -1) {
            continue
          }
          if (!payload.groups[key] && before.groups[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.delete(refChatsRefTo)
          }
        }
        batch.commit().then(function () {
          resolve()
        })
      })
    },
    groupClean (key) {
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      return new Promise((resolve) => {
        var refGroup = db.collection('groups').doc(key)
        db.runTransaction(function (transaction) {
          return transaction.get(refGroup).then(function (doc) {
            if (!doc.exists) {
              resolve()
              return
            }
            var services = {}
            var keys = Object.keys(doc.data().services)
            for (var x in keys) {
              if (doc.data().services[keys[x]]) {
                services[keys[x]] = true
              }
            }
            var users = {}
            keys = Object.keys(doc.data().users)
            for (x in keys) {
              if (doc.data().users[keys[x]]) {
                users[keys[x]] = true
              }
            }
            transaction.update(refGroup, { services: services, users: users })
            transaction.update(refGroup, { updatedAt: parseInt(new Date().getTime() / 1000) })
          })
        }).then(function () {
          resolve()
        }).catch(function (error) {
          console.log('Transaction failed: ', error)
          resolve()
        })
      })
    },
    cleanUser () {
      return new Promise((resolve) => {
        var vm = this
        var async = require('async')
        async.each(vm.users, function (user, cb) {
          if (user.services[vm.myServiceSelected]) {
            vm.userClean(JSON.parse(JSON.stringify(user))).then(function () {
              cb()
            })
          } else {
            cb()
          }
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    cleanGroup () {
      return new Promise((resolve) => {
        var vm = this
        var async = require('async')
        async.each(vm.groups, function (group, cb) {
          if (group.services[vm.myServiceSelected]) {
            vm.groupClean(group.key).then(function () {
              cb()
            })
          } else {
            cb()
          }
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    cleanService () {
      var vm = this
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      return new Promise((resolve) => {
        var refService = db.collection('services').doc(vm.myServiceSelected)
        db.runTransaction(function (transaction) {
          return transaction.get(refService).then(function (doc) {
            if (!doc.exists) {
              resolve()
              return
            }
            var groups = {}
            var keys = Object.keys(doc.data().groups)
            for (var x in keys) {
              if (doc.data().groups[keys[x]]) {
                groups[keys[x]] = true
              }
            }
            var users = {}
            keys = Object.keys(doc.data().users)
            for (x in keys) {
              if (doc.data().users[keys[x]]) {
                users[keys[x]] = true
              }
            }
            transaction.update(refService, { groups: groups, users: users })
            transaction.update(refService, { updatedAt: parseInt(new Date().getTime() / 1000) })
          })
        }).then(function () {
          resolve()
        }).catch(function (error) {
          console.log('Transaction failed: ', error)
          resolve()
        })
      })
    },
    onClick () {
      var vm = this
      vm.onLoading()
      vm.cleanGroup().then(function () {
        vm.cleanUser().then(function () {
          vm.cleanService().then(function () {
            vm.offLoading()
          })
        })
      })
    },
    createServiceSelector () {
      this.myServiceSelected = null
      this.myService = []
      if (this.user) {
        for (var i in this.services) {
          var service = JSON.parse(JSON.stringify(this.services[i]))
          this.myService.push({
            value: service.key,
            text: service.name
          })
        }
      }
      if (this.myService.length !== 0) {
        this.myServiceSelected = this.myService[0].value
      }
    },
    makeChatStatics (key) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)

        var payload = {
          unread: {},
          read: {},
          last: null
        }
        var ref = db.collection('chats').doc(key).collection('data')
        ref.orderBy('createdAt', 'desc').limit(100).get().then(function (snapshots) {
          if (!snapshots.empty) {
            snapshots.forEach(function (doc) {
              var data = doc.data()
              if (data.visible) {
                if (!data.read) {
                  if (typeof payload.unread[data.to] === 'undefined') {
                    payload.unread[data.to] = 1
                  } else {
                    payload.unread[data.to] += 1
                  }
                  if (typeof payload.read[data.from] === 'undefined') {
                    payload.read[data.from] = 1
                  } else {
                    payload.read[data.from] += 1
                  }
                }
                if (payload.last === null) {
                  payload.last = data
                }
              }
            })
          }
          ref = db.collection('chats').doc(key)
          ref.update(payload).then(function () {
            resolve()
          })
        })
      })
    },
    onMakeChatStatics () {
      var vm = this
      this.onLoading()
      var async = require('async')
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      var dbRef = db.collection('chats')
      dbRef.orderBy('createdAt', 'desc').get().then(function (snapshots) {
        if (!snapshots.empty) {
          var count = snapshots.docs.length
          async.eachSeries(snapshots.docs, function (doc, cb) {
            vm.makeChatStatics(doc.id).then(function () {
              console.log('make statics: ', doc.id, count)
              const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
              pause(50).then(() => {
                count -= 1
                cb()
              })
            })
          }, function (error) {
            if (error) {
              console.log(error)
            }
            vm.offLoading()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
// Basic styles are pulled in from the Bulma framework https://bulma.io/
// These style tags could be omitted as they arre not used.
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue